import { render, staticRenderFns } from "./BillHistory.vue?vue&type=template&id=82408bc4&scoped=true"
import script from "./BillHistory.vue?vue&type=script&lang=js"
export * from "./BillHistory.vue?vue&type=script&lang=js"
import style0 from "./BillHistory.vue?vue&type=style&index=0&id=82408bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82408bc4",
  null
  
)

export default component.exports